import { Injectable } from '@angular/core';
import { HttpHeaders, HttpClient } from "@angular/common/http";
import { catchError, map, tap } from 'rxjs/operators';
import { Observable, of } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class PrivacyPolicyService {
  apiUrl = null;
  apiUrlPrivacyPolicy = null;
  appID = null;
  constructor(private http: HttpClient) { }
  getAccessToken(){
    return localStorage.getItem('access_token');
  }
  private getHeaders(file = false,cache=false) {
    let headers = new HttpHeaders();
    if(!file){
      headers = new HttpHeaders({ 'Content-Type': 'application/json' });
    }
    if(cache){
      headers = new HttpHeaders({ 'cache-response': 'true','Content-Type': 'application/json' });
    }
    headers = headers.set('Authorization', `Bearer ${this.getAccessToken()}`);
    return headers;
  }
  getApi(url: string):Observable<any> {
    return this.http.get(url, { headers: this.getHeaders() }).pipe(
      map(res => res),
      catchError(err => { this.catchError(err); return of(err.message) })
    );
  }
  postApi(url: string,postValue:any, file = false,cache=false):Observable<any> {
    return this.http.post(url, postValue,{ headers: this.getHeaders(file,cache) }).pipe(
      map(res => res),
      catchError(err => { this.catchError(err); return of(err.message) })
    );
  }
  putApi(url: string,postValue:any, file = false,cache=false):Observable<any> {
    return this.http.put(url, postValue,{ headers: this.getHeaders(file,cache) }).pipe(
      map(res => res),
      catchError(err => { this.catchError(err); return of(err.message) })
    );
  }
  deleteApi(url: string):Observable<any> {
    return this.http.delete(url, { headers: this.getHeaders() }).pipe(
      map(res => res),
      catchError(err => { this.catchError(err); return of(err.message) })
    );
  }
  catchError(err) {    
    throw err;
  }
  getPrivacyPolicyByCountry(postData) {
    return this.postApi(this.apiUrlPrivacyPolicy + "MasterData/GetPrivatePolicy",postData,true);
  }
  getTermsByCountry(postData) {
    return this.postApi(this.apiUrlPrivacyPolicy + "MasterData/GetTermConditionPolicy",postData,true);
  }
  updateTermsAndPolicy(postData,appId) {
    return this.putApi(this.apiUrl + "AppSubscription/UpdateAppPolicyAgreements/"+appId,postData,true);
  }
}
